module.exports = __webpack_public_path__ + "img/bind_success.cb798dea.png";